import { useState } from 'react';

interface NavigationProps {
  scrolled: boolean;
}

export default function Navigation({ scrolled }: NavigationProps) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const navLinks = [
    { name: 'HOME', href: '#home' },
    { name: 'PARTS', href: '#parts' },
    { name: 'SERVICES', href: '#services' },
    { name: 'REVIEWS', href: '#reviews' },
    { name: 'ABOUT', href: '#about' },
    { name: 'LOCATION', href: '#location' }
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="w-full px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="w-1 h-10 bg-red-600"></div>
            <div>
              <div className={`font-rajdhani font-bold text-xl leading-tight ${scrolled ? 'text-black' : 'text-white'}`}>
                N.A. DISCOUNT
              </div>
              <div className={`font-rajdhani font-bold text-xl leading-tight ${scrolled ? 'text-black' : 'text-white'}`}>
                AUTO PARTS
              </div>
            </div>
          </div>

          <div className="hidden lg:flex items-center gap-8">
            {navLinks.map((link) => (
              <a
                key={link.name}
                href={link.href}
                className={`font-rajdhani font-medium text-sm tracking-wider hover:text-red-600 transition-colors cursor-pointer ${
                  scrolled ? 'text-gray-800' : 'text-white'
                }`}
              >
                {link.name}
              </a>
            ))}
          </div>

          <a
            href="tel:905-226-0408"
            className="hidden lg:inline-flex items-center gap-2 bg-red-600 hover:bg-red-700 text-white px-6 py-3 rounded-full font-rajdhani font-bold transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-phone-fill"></i>
            905-226-0408
          </a>

          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className={`lg:hidden w-10 h-10 flex items-center justify-center ${scrolled ? 'text-black' : 'text-white'} cursor-pointer`}
            aria-label="Toggle menu"
          >
            <i className={`text-2xl ${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileMenuOpen && (
        <div className="lg:hidden bg-white border-t border-gray-200">
          <div className="px-6 py-4 space-y-3">
            {navLinks.map((link) => (
              <a
                key={link.name}
                href={link.href}
                onClick={() => setMobileMenuOpen(false)}
                className="block font-rajdhani font-medium text-gray-800 hover:text-red-600 transition-colors cursor-pointer"
              >
                {link.name}
              </a>
            ))}
            <a
              href="tel:905-226-0408"
              className="block w-full text-center bg-red-600 text-white px-6 py-3 rounded-full font-rajdhani font-bold cursor-pointer"
            >
              <i className="ri-phone-fill mr-2"></i>
              905-226-0408
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}
